import gql from "graphql-tag";

export default gql`
  query MyPermissions {
    myPermissions {
      id
      role
      permissionKey
      allowed
    }
  }
`;
